import { render } from "./bread.vue?vue&type=template&id=2e953806"
import script from "./bread.vue?vue&type=script&lang=js"
export * from "./bread.vue?vue&type=script&lang=js"

import "./bread.vue?vue&type=style&index=0&id=2e953806&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__